import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LogoService {
    private _httpClient = inject(HttpClient);


    getSvg(url: string): Observable<string> {
        const sub = this._httpClient.get(url, { responseType: 'text' });

        return sub;
    }
}
